import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name play-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAuMjE1IDQuNTYgOS43OSA1LjcxYTIgMiAwIDAgMSAuMDAzIDMuNDU4bC0uMzkzLjIzIiAvPgogIDxwYXRoIGQ9Im0xNi4wNDIgMTYuMDQyLTguMDM0IDQuNjg2QTIgMiAwIDAgMSA1IDE5VjUiIC8+CiAgPHBhdGggZD0ibTIgMiAyMCAyMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/play-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const PlayOff: IconNode = [
  ['path', { d: 'm10.215 4.56 9.79 5.71a2 2 0 0 1 .003 3.458l-.393.23' }],
  ['path', { d: 'm16.042 16.042-8.034 4.686A2 2 0 0 1 5 19V5' }],
  ['path', { d: 'm2 2 20 20' }],
];

export default PlayOff;
